import { render } from "./LockIcon.vue?vue&type=template&id=1285f752"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/LockIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1285f752"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1285f752', __exports__)) {
    api.reload('1285f752', __exports__)
  }
  
  module.hot.accept("./LockIcon.vue?vue&type=template&id=1285f752", () => {
    api.rerender('1285f752', render)
  })

}


export default __exports__